import React, { forwardRef, ReactElement } from 'react';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import Spinner from '@atlaskit/spinner';

const StyledSpinner: React.ComponentType<any> = forwardRef<HTMLSpanElement>(
  ({ ...props }, ref) => (
    <span ref={ref} {...props}>
      <Spinner size="small" />
    </span>
  )
);

export const DropdownWebItemLoading = (): ReactElement => (
  <DropdownItem component={StyledSpinner}> </DropdownItem>
);
